import state from "./state";
import mutations from "./mutations";

const overviewPage = {
  namespaced: true,
  state,
  mutations,
};

export default overviewPage;
